import { render, staticRenderFns } from "./AppPageNotFoundHeader.vue?vue&type=template&id=c580a2f2&scoped=true&"
import script from "./AppPageNotFoundHeader.vue?vue&type=script&lang=js&"
export * from "./AppPageNotFoundHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppPageNotFoundHeader.vue?vue&type=style&index=0&id=c580a2f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c580a2f2",
  null
  
)

export default component.exports